import { MARINE } from './chartColors.js'
import { linear, segmentsOf } from './scales.js'

const WIDTH = 120
const HEIGHT = 28
const PAD = 3

/**
 * A figure's months in one stroke; a month with nothing breaks the line. The stroke fills its box, so a round mark
 * would stretch and none is drawn. `minRange` keeps a wobble from reading as a swing: the vertical scale never
 * spans less than it.
 */
export function Sparkline({ series, color = MARINE, label, minRange = 0, className = '' }: { series: readonly (number | null)[]; color?: string; label: string; minRange?: number; className?: string }) {
  const present = series.filter((value): value is number => value !== null)
  if (present.length < 2) {
    return (
      <svg role="img" aria-label={label} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} className={`h-7 w-full ${className}`} preserveAspectRatio="none">
        <line x1={0} y1={HEIGHT / 2} x2={WIDTH} y2={HEIGHT / 2} stroke={color} strokeOpacity={0.25} strokeWidth={1} strokeDasharray="2 3" />
      </svg>
    )
  }
  const x = (index: number): number => (index / Math.max(1, series.length - 1)) * WIDTH
  const low = Math.min(...present)
  const high = Math.max(...present)
  const pad = Math.max(0, (minRange - (high - low)) / 2)
  const y = linear(low - pad, high + pad, HEIGHT - PAD, PAD)
  return (
    <svg role="img" aria-label={label} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} className={`h-7 w-full ${className}`} preserveAspectRatio="none">
      {segmentsOf(series, x, y).map((points, index) => (
        <polyline key={index} points={points} fill="none" stroke={color} strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
      ))}
    </svg>
  )
}
